var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-3",
            label: "Logo Size:",
            "label-for": "input-3",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-3",
              options: _vm.form.settings.logoSizeOptions,
              required: "",
            },
            model: {
              value: _vm.form.values.modalLogoSize,
              callback: function ($$v) {
                _vm.$set(_vm.form.values, "modalLogoSize", $$v)
              },
              expression: "form.values.modalLogoSize",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-3",
            label: "Modal Size:",
            "label-for": "input-3",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-3",
              options: _vm.form.settings.modalSizeOptions,
              required: "",
            },
            model: {
              value: _vm.form.values.modalSize,
              callback: function ($$v) {
                _vm.$set(_vm.form.values, "modalSize", $$v)
              },
              expression: "form.values.modalSize",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-3",
            label: "Modal Border Width:",
            "label-for": "input-3",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-3",
              options: _vm.form.settings.modalBorderWidthOptions,
              required: "",
            },
            model: {
              value: _vm.form.values.modalBorderStyle,
              callback: function ($$v) {
                _vm.$set(_vm.form.values, "modalBorderStyle", $$v)
              },
              expression: "form.values.modalBorderStyle",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-3",
            label: "Modal Border Radius:",
            "label-for": "input-3",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-3",
              options: _vm.form.settings.modalBorderRadiusOptions,
              required: "",
            },
            model: {
              value: _vm.form.values.modalBorderRadius,
              callback: function ($$v) {
                _vm.$set(_vm.form.values, "modalBorderRadius", $$v)
              },
              expression: "form.values.modalBorderRadius",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-3",
            label: "Submit Button Type:",
            "label-for": "input-3",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-3",
              options: _vm.form.settings.submitButtonTypeOptions,
              required: "",
            },
            model: {
              value: _vm.form.values.submitType,
              callback: function ($$v) {
                _vm.$set(_vm.form.values, "submitType", $$v)
              },
              expression: "form.values.submitType",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-3",
            label: "Submit Button Style Options:",
            "label-for": "input-3",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-3",
              options: _vm.form.settings.submitButtonStyleOptions,
              required: "",
            },
            model: {
              value: _vm.form.values.submitStyle,
              callback: function ($$v) {
                _vm.$set(_vm.form.values, "submitStyle", $$v)
              },
              expression: "form.values.submitStyle",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }